import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import BoletoDefault from '../BoletoPage/BoletoDefault/index';
import { IThankYouPage } from 'interfaces/IThankYouPage';
import { SvgIcon } from 'components/SvgIcon';
import { enPixelPath, pixelService } from 'services/PixelService';

const styles = require('./boletoWidget.css');

interface IState extends IStateBase {
  data: IThankYouPage;
}

interface IProps {
  infos: any;
}

export default class BoletoWidgetPage extends BaseComponent<IState, IProps>{

  constructor(props: any) {
    super(props);

    window.parent.postMessage({ EdzWidgetPayment: props.infos }, '*');
  }

  componentDidMount() {
    pixelService.track(enPixelPath.THANKYOU_BANKSLIP);
  }

  closeWidget = () => {
    window.parent.postMessage('EdzWidgetClose', '*');
  }

  render() {
    return (
      <div className={styles.component}>
        <div className='chk-content-container'>
          <div className='chk-container'>
            <button id='chk-widget-close-button' className='chk-multiStep__closeForm theme-button' onClick={this.closeWidget}>
              <SvgIcon name='closeIcon' />
            </button>
            <BoletoDefault infos={this.props.infos} />
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ThankYouPage/BoletoWidgetPage/index.tsx